export default "__VITE_ASSET__Qb5p6vI7__"